import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

export const AgentLoginDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="rounded-2xl sm:max-w-md" data-testid="agent-login-dialog">
      <DialogHeader>
        <p className="eyebrow">Travel trade</p>
        <DialogTitle className="font-serif text-3xl font-normal">Agent Login</DialogTitle>
        <DialogDescription>Sign in with your eRes agent credentials to book on behalf of clients.</DialogDescription>
      </DialogHeader>
      <form
        className="space-y-3"
        onSubmit={(e) => {
          e.preventDefault();
          toast.info("Agent login will connect to your eRes agent service", { description: "Demo preview: not connected yet." });
          onOpenChange(false);
        }}
      >
        <input className="field-input" placeholder="Agent code" required data-testid="agent-login-code" />
        <input className="field-input" placeholder="Username" required data-testid="agent-login-username" />
        <input className="field-input" type="password" placeholder="Password" required data-testid="agent-login-password" />
        <button className="btn-primary w-full" data-testid="agent-login-submit">Log in</button>
      </form>
    </DialogContent>
  </Dialog>
);
